import { httpClient } from '../httpClient';

export const autoChecksMethods = {
  // ── Spec 020 Auto-Checks (renamed from "Assessment Intelligence" 2026-Q2) ───
  // URLs flipped to canonical `/auto-checks/*` per PR4 dual-mount; the legacy
  // `/intelligence/*` prefix still returns 200 with a Deprecation header until
  // it is removed in a follow-up. Function names + cache keys keep their
  // historical `Intel` spelling to avoid churning ~30 consumer files; the
  // user-visible rename lives in i18n + HTTP path.
  triggerIntelRun: (assessmentId, body = {}) =>
    httpClient.post(
      `/pdpl/assessments/${assessmentId}/auto-checks/runs`,
      body,
    ),

  listIntelRuns: (assessmentId, params) =>
    httpClient.get(
      `/pdpl/assessments/${assessmentId}/auto-checks/runs`,
      { params },
    ),

  getIntelRun: (runId) =>
    httpClient.get(`/pdpl/auto-checks/runs/${runId}`),

  getIntelRunStatus: (runId) =>
    httpClient.get(`/pdpl/auto-checks/runs/${runId}/status`),

  cancelIntelRun: (runId) =>
    httpClient.post(`/pdpl/auto-checks/runs/${runId}/cancel`, {}),

  getIntelPreview: (assessmentId) =>
    httpClient.get(
      `/pdpl/assessments/${assessmentId}/auto-checks/preview`,
    ),

  // ── Plan 2 Task 2 — drift inbox feed (canonical /auto-checks/* path) ──
  // Backend (intelligence_routes.list_drift_events_route) returns
  // `{ data: { events: [...], total, unseen_count } }`. The hook layer
  // unwraps `response.data.data` — kept as a raw axios call here to match
  // the existing pdplApi convention (no `.then(r => r.data)` mutation).
  listDriftEvents: ({ assessmentId, status = 'unseen', limit = 50, includeDismissed = false } = {}) =>
    httpClient.get('/pdpl/auto-checks/drift-events', {
      params: {
        assessment_id: assessmentId,
        status,
        limit,
        include_dismissed: includeDismissed,
      },
    }),

  // ── Plan 2 Task 10 — drift inbox mutations ─────────────────────────────
  // Backend returns the updated event dict at `response.data.data`; the
  // hook layer is responsible for unwrapping. Kept here as raw httpClient
  // calls to match the existing pdplApi convention (no `.then` projection).
  markDriftEventSeen: (eventId) =>
    httpClient.post(`/pdpl/auto-checks/drift-events/${eventId}/seen`, {}),

  dismissDriftEvent: (eventId) =>
    httpClient.post(`/pdpl/auto-checks/drift-events/${eventId}/dismiss`, {}),

  // ── Plan 1 Task 11 — per-run remediation playbook entries ──────────────
  // Backend (intelligence_routes.get_run_remediation_route) returns
  // `{ data: { run_id, remediations: [...] } }`. Hook layer unwraps
  // `response.data.data`; the side-panel footer (Plan 2 Task 16) filters
  // the array down to the entry whose ``check_key`` matches the open check.
  listRemediations: (runId) =>
    httpClient.get(`/pdpl/auto-checks/runs/${runId}/remediation`),

  // ── Plan 2 Task 3 — manual-question upstream context (P1-10) ───────────
  // Backend (intelligence_routes.get_question_context_route) returns
  // `{ data: { question_ext_id, category_id, context: { key: {count, deep_link} } } }`.
  // Hook layer unwraps `response.data.data`.
  getQuestionContext: (questionExtId, assessmentId) =>
    httpClient.get(`/pdpl/questions/${questionExtId}/context`, {
      params: { assessment_id: assessmentId },
    }),
};
